import React, { useEffect, useMemo, useState } from "react";
import LedgerAccountBasicInfoForm from "./LedgerAccountBasicInfoForm";
import LedgerAccountAddress from "./LedgerAccountAddress";
import LedgerAccountTaxDetails from "./LedgerAccountTaxDetails";
import LedgerAccountBankDetails from "./LedgerAccountBankDetails";
import LedgerAccountContactInfo from "./LedgerAccountContactInfo";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { adminMainUrl } from "../../../../Config";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllMasterAccountGroupIdAndName,
  getAllMasterAccountLedgerGroupTypeIdAndName,
  getAllMasterAccountTdsCategoryIdAndName,
  getAllMasterRcmCategoryIdAndName,
  getGroupMasterIdAndName,
} from "../../../../Redux/action/MasterAction";
import { generateCode } from "../../../../helper/autoGenId";
import { useLocation, useNavigate } from "react-router-dom";

const LedgerAccount = () => {
  const token = Cookies.get("token");
  const user_id = Cookies.get("flexichain_user_id");
  const ledger_account_id = localStorage.getItem("ledger_account_id");

  const {
    MasterAccountGroupName,
    loadingMasterAccountGroupName,

    MasterAccountTdsCategoryName,
    loadingMasterAccountTdsCategoryName,

    MasterAccountLedgerGroupTypeName,
    loadingMasterAccountLedgerGroupTypeName,

    GroupMasterName,
    loadingGroupMasterName,
  } = useSelector((state) => state?.MasterReducer);

  const [userGst, setUserGst] = useState("");
  const [userInfoViaGst, setUserInfoViaGst] = useState({});

  const [ledgerFormData, setLedgerFormData] = useState({
    ledger_type: "",
    ledger_gst: "",

    // badic_info
    ledger_code: "",
    ledger_party_name: "",
    ledger_group: "",
    ledger_sales_person: "",
    ledger_account_group: "",
    ledger_credit_limit: "",
    ledger_opening_balance: "",
    ledger_debit_or_credit: "",
    ledger_credit_day: "",

    //address
    addresses: [
      {
        address_line_one: "",
        address_line_two: "",
        city: "",
        state: "",
        country: "",
        pincode: "",
      },
    ],

    //tax details
    tds_applicable: "",
    tds_category: "",
    tds_percentage: "",
    pan_number: "",

    bank_details: [
      {
        branch_name: "",
        confirm_account_number: "",
        account_number: "",
        branch_address: "",
        ifsc_code: "",
      },
    ],

    //contact info
    contact: [
      {
        contact_person: "",
        mobile_number: "",
        email: "",
        city: "",
        state: "",
        country: "",
        pincode: "",
        address: "",
      },
    ],
  });

  // console.log("ledgerFormData", ledgerFormData);
  // console.log("userInfoViaGst", userInfoViaGst);

  const [activeTab, setActiveTab] = useState("basic_info");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;
  const queryParams = new URLSearchParams(location.search);

  const TabButton = ({ id, label }) => (
    <button
      className={`btn mx-1 px-4 py-2 rounded-pill ${
        activeTab === id
          ? "btn-light shadow-sm border"
          : "btn-outline-light text-muted border"
      }`}
      style={{
        background: activeTab === id ? "#ffffff" : "#f5f5f5",
        borderColor: "#e4e4e4",
      }}
      onClick={() => setActiveTab(id)}
    >
      {label}
    </button>
  );

  const nonNegativeFields = [
    "ledger_credit_limit",
    "ledger_credit_day",
    "ledger_opening_balance",
    "tds_percentage",
  ];

  const onValueChange = (e) => {
    const { name, type, value, checked } = e.target;
    // ledger_credit_limit, ledger_credit_day, ledger_opening_balance

    let finalValue = value;
    // If input type is number
    if (type === "number") {
      const numericValue = Number(value);

      // Block negative values for fixed fields
      if (nonNegativeFields.includes(name) && numericValue <= 0) {
        finalValue = ""; // or "" if you prefer empty
      } else {
        finalValue = numericValue;
      }
    }

    if (name === "tds_percentage") {
      if (value > 100) {
        finalValue = 100;
      }
    }

    setLedgerFormData((pre) => ({
      ...pre,
      [name]: type === "checkbox" ? checked : finalValue,
    }));
  };

  const onAddressChange = (index, e) => {
    const { name, type, value, checked } = e.target;
    const updated = [...ledgerFormData.addresses];
    updated[index][name] = value;

    setLedgerFormData({ ...ledgerFormData, addresses: updated });
  };

  const addAddress = () => {
    setLedgerFormData((prev) => ({
      ...prev,
      addresses: [
        ...prev.addresses,
        {
          address_line_one: "",
          address_line_two: "",
          city: "",
          state: "",
          country: "",
          pincode: "",
        },
      ],
    }));
  };

  const removeAddress = (index) => {
    setLedgerFormData((prev) => ({
      ...prev,
      addresses: prev.addresses.filter((_, i) => i !== index),
    }));
  };

  // add new bank fun
  const onBankChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...ledgerFormData.bank_details];
    updated[index][name] = value;

    setLedgerFormData({ ...ledgerFormData, bank_details: updated });
  };

  const addBank = () => {
    setLedgerFormData((prev) => ({
      ...prev,
      bank_details: [
        ...prev.bank_details,
        {
          branch_name: "",
          confirm_account_number: "",
          account_number: "",
          branch_address: "",
          ifsc_code: "",
        },
      ],
    }));
  };

  const removeBank = (index) => {
    setLedgerFormData((prev) => ({
      ...prev,
      bank_details: prev.bank_details.filter((_, i) => i !== index),
    }));
  };

  //add new contact fun

  const onContactChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...ledgerFormData.contact];
    updated[index][name] = value;
    setLedgerFormData({ ...ledgerFormData, contact: updated });
  };

  const addContact = () => {
    setLedgerFormData((prev) => ({
      ...prev,
      contact: [
        ...prev.contact,
        {
          contact_person: "",
          mobile_number: "",
          email: "",
          city: "",
          state: "",
          pincode: "",
          address: "",
        },
      ],
    }));
  };

  const removeContact = (index) => {
    setLedgerFormData((prev) => ({
      ...prev,
      contact: prev.contact.filter((_, i) => i !== index),
    }));
  };

  const submitGroupForm = async (tabId) => {
    // alert("group form submit");
    // console.log("ledgerFormData", ledgerFormData);
    // clearGroupForm();
    // try {
    //   const response = await fetch(
    //     `${adminMainUrl}/api/account/ledger-account`,
    //     {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //         "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
    //         user_id: Cookies.get("flexichain_user_id"),
    //       },
    //       body: JSON.stringify(ledgerFormData),
    //     }
    //   );
    //   const data = await response.json();
    //   if (response.ok) {
    //     // closeButtonRef.current.click();
    //     // if (onSuccess) onSuccess();
    //     toast.success(data?.msg);
    //     clearGroupForm();
    //   } else {
    //     toast.error(data?.msg);
    //     // Handle errors from the server
    //     console.error("Error creating master currency:", data.message);
    //   }
    // } catch (error) {
    //   console.error("Network error:", error);
    // }

    setActiveTab(tabId);
  };

  const clearGroupForm = () => {
    setLedgerFormData({
      ledger_type: "",
      ledger_gst: "",

      // badic_info
      ledger_code: "",
      ledger_party_name: "",
      ledger_group: "",
      ledger_sales_person: "",
      ledger_account_group: "",
      ledger_credit_limit: "",
      ledger_opening_balance: "",
      ledger_debit_or_credit: "",
      ledger_credit_day: "",

      //address
      addresses: [
        {
          address_line_one: "",
          address_line_two: "",
          city: "",
          state: "",
          country: "",
          pincode: "",
        },
      ],

      //tax details
      tds_applicable: "",
      tds_category: "",
      tds_percentage: "",
      pan_number: "",

      bank_details: [
        {
          branch_name: "",
          confirm_account_number: "",
          account_number: "",
          branch_address: "",
          ifsc_code: "",
        },
      ],

      //contact info
      contact: [
        {
          contact_person: "",
          mobile_number: "",
          email: "",
          city: "",
          state: "",
          country: "",
          pincode: "",
          address: "",
        },
      ],
    });
  };

  const saveAndNext = (tabId) => {
    setActiveTab(tabId);
  };

  const getUserInfoVisGst = async (gst) => {
    try {
      const response = await fetch(
        `${adminMainUrl}/api/account/company-account-details`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
          },
          body: JSON.stringify({ gst }),
        },
      );

      const data = await response.json();

      // console.log("gst data", data?.data);

      setUserInfoViaGst(data.data);

      if (response.ok) {
        toast.success(data?.msg);
      } else {
        toast.error(data?.msg);
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };

  useEffect(() => {
    if (!userGst) return;

    const delay = setTimeout(() => {
      getUserInfoVisGst(userGst);
    }, 2000); // ⏱️ debounce time (500ms)

    return () => clearTimeout(delay); // cleanup on change
  }, [userGst]);

  useEffect(() => {
    if (!userInfoViaGst) return;

    setLedgerFormData((prev) => ({
      ...prev,
      ledger_gst: userInfoViaGst.GST ?? "",
      ledger_sales_person: userInfoViaGst.salesPersonName ?? "",
      pan_number: userInfoViaGst.PAN ?? "",
      ledger_credit_day: userInfoViaGst.creditPeriodDays ?? "",
      ledger_credit_limit: userInfoViaGst.totalCreditLimit ?? "",
      ledger_party_name: userInfoViaGst.name ?? "",

      addresses: [
        {
          address_line_one: userInfoViaGst?.address_line_one ?? "",
          address_line_two: userInfoViaGst?.address_line_two ?? "",
          city: "",
          state: "",
          country: "",
          pincode: userInfoViaGst?.pincode ?? "",
        },
      ],

      bank_details: [
        {
          branch_name: userInfoViaGst.bankName ?? "",
          confirm_account_number: userInfoViaGst.bankAccountNum ?? "",
          account_number: userInfoViaGst.bankAccountNum ?? "",
          branch_address: userInfoViaGst.bankAddress ?? "",
          ifsc_code: userInfoViaGst.ifscCode ?? "",
        },
      ],

      contact: [
        {
          contact_person: userInfoViaGst?.username || "",
          mobile_number: userInfoViaGst?.mobile || "",
          email: userInfoViaGst?.email || "",
          city: "",
          state: "",
          country: "",
          pincode: userInfoViaGst?.pincode || "",
          address: userInfoViaGst?.permanentRegaddress || "",
        },
      ],
    }));
  }, [userInfoViaGst]);

  useEffect(() => {
    localStorage.removeItem("ledger_account_id");
  }, []);

  useEffect(() => {
    if (token && user_id) {
      let invoice_id = generateCode();
      if (invoice_id) {
        setLedgerFormData((pre) => ({
          ...pre,
          ["ledger_code"]: invoice_id,
        }));
      }

      dispatch(getAllMasterAccountGroupIdAndName(token, user_id));
      dispatch(getAllMasterAccountTdsCategoryIdAndName(token, user_id));
      dispatch(getAllMasterAccountLedgerGroupTypeIdAndName(token, user_id));
      dispatch(getGroupMasterIdAndName(token, user_id));
    } else {
      toast.error("Please login to continue.");
      navigate(`/login?burl=${encodeURIComponent(q)}`);
    }
  }, [token, user_id, location.search]);

  return (
    <>
      <style>
        {`
          .padding-pt-9 {
            padding: 10px;
          }
        `}
      </style>
      <div>
        <h5 className="fw-semibold mb-3">Ledger Account Master Form</h5>
        <div className="row">
          {/* currency_code */}
          <div className="col-md-6 mb-4">
            <label className="form-label fw-medium">
              Ledger Type <span className="text-danger">*</span>
            </label>
            <select
              onChange={onValueChange}
              value={ledgerFormData.ledger_type}
              name="ledger_type"
              className="form-select bg-light padding-pt-9"
            >
              <option value="">Select Ledger Type </option>
              {MasterAccountLedgerGroupTypeName?.map((item, i) => (
                <option key={i} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          {/* Group Name */}

          <div className="col-md-6 mb-4">
            <label className="form-label fw-medium">
              GST Number <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="ledger_gst"
              className="form-control bg-light"
              placeholder="Enter GST Number"
              onChange={(e) => setUserGst(e.target.value)}
              // onChange={onValueChange}
              // value={ledgerFormData.ledger_gst}
              value={userGst}
            />
          </div>

          {/* Tabs */}
          <div className="d-flex flex-wrap align-items-center mb-4 gap-2">
            <TabButton id="basic_info" label="Basic Info" />
            <TabButton id="address" label="Address" />
            <TabButton id="tax_details" label="Tax Details" />
            <TabButton id="Bank_details" label="Bank Details" />
            <TabButton id="contact_info" label="Contact Info" />
          </div>

          {/* GROUP FORM -------------------------------------------------- */}
          {activeTab === "basic_info" && (
            <LedgerAccountBasicInfoForm
              ledger_account_id={ledger_account_id}
              ledgerFormData={ledgerFormData}
              onValueChange={onValueChange}
              saveAndNext={saveAndNext}
              tabId={"address"}
            />
          )}

          {/* address */}
          {activeTab === "address" && (
            <LedgerAccountAddress
              ledger_account_id={ledger_account_id}
              addresses={ledgerFormData.addresses}
              onAddressChange={onAddressChange}
              onAddNew={addAddress}
              onRemove={removeAddress}
              saveAndNext={saveAndNext}
              tabId={"tax_details"}
              backId={"basic_info"}
            />
          )}

          {/* tax_details */}
          {activeTab === "tax_details" && (
            <LedgerAccountTaxDetails
              ledger_account_id={ledger_account_id}
              ledgerFormData={ledgerFormData}
              onValueChange={onValueChange}
              saveAndNext={saveAndNext}
              tabId={"Bank_details"}
              backId={"address"}
            />
          )}

          {/* Bank_details */}
          {activeTab === "Bank_details" && (
            <LedgerAccountBankDetails
              ledger_account_id={ledger_account_id}
              bank_details={ledgerFormData.bank_details}
              onBankChange={onBankChange}
              onAddNew={addBank}
              onRemove={removeBank}
              saveAndNext={saveAndNext}
              tabId={"contact_info"}
              backId={"tax_details"}
            />
          )}

          {/* contact_info */}
          {activeTab === "contact_info" && (
            <LedgerAccountContactInfo
              ledger_account_id={ledger_account_id}
              contact={ledgerFormData.contact}
              onContactChange={onContactChange}
              addContact={addContact}
              removeContact={removeContact}
              saveAndNext={saveAndNext}
              tabId={"basic_info"}
              backId={"Bank_details"}
              clearGroupForm={clearGroupForm}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default LedgerAccount;
